import {Injectable} from '@angular/core';
import {featureFlagStore} from './feature-flag.store';

@Injectable({providedIn: 'root'})
export class FeatureFlagManager {
  public toggleFeature(key: string) {
    featureFlagStore.update(state => {
      const feature = state[key];
      return {
        ...state,
        [key]: {
          ...feature,
          value: !feature.value,
        },
      };
    });
  }

  public reset() {
    featureFlagStore.reset();
  }
}
